import { featureFlagService } from 'utils/featureFlagService'
import { CompanyPageLayoutOld } from './CompanyPageLayoutOld'
import { CompanyPageLayoutNew } from './CompanyPageLayoutNew'
import type { CompanySidebarHeader, SidebarTabConfig } from './Sidebar'
import type { BreadcrumbItem } from 'components/Layout/Header/types'

// Export CompanyContentSections for use in company pages
export { CompanyContentSections } from './CompanyContentSections'

/**
 * TODO: Cleanup when old navigation is fully deprecated (enableNewNavigation flag removed)
 *
 * 1. Delete these files:
 *    - CompanyPageLayoutOld.tsx
 *    - Sidebar/CompanySidebarOld.tsx
 *    - CompanyPageContext.tsx (useIsNewNavigation no longer needed)
 *
 * 2. Rename these files:
 *    - CompanyPageLayoutNew.tsx → CompanyPageLayout.tsx (inline here or keep separate)
 *    - Sidebar/CompanySidebarNew.tsx → Sidebar/CompanySidebar.tsx
 *
 * 3. Simplify this file:
 *    - Remove feature flag check
 *    - Remove breadcrumbRoot/breadcrumbs props (not used in new nav)
 *    - Export CompanyPageLayoutNew directly as CompanyPageLayout
 *
 * 4. Clean up child components:
 *    - Remove useIsNewNavigation() checks in CompanyTopCard, EventHistoryList, etc.
 *    - Remove conditional styling for old vs new nav
 *
 * 5. Update Sidebar/SidebarContent.tsx:
 *    - Can become the main CompanySidebar component directly
 */

interface CompanyPageLayoutProps {
  breadcrumbRoot: string
  breadcrumbs?: { breadcrumb: string; title?: string; url?: string }[]
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
  /** Entity breadcrumbs for new navigation header (e.g., Chain: McDonald's | Door: Store #123) */
  entityBreadcrumbs?: BreadcrumbItem[]
  /** Dynamic category info for unmatched/user-generated pages */
  categoryInfo?: {
    categorySlug: string
    subCategorySlug: string
  }
}

/**
 * Company page layout that switches between old and new navigation modes.
 * See TODO above for cleanup steps when old navigation is deprecated.
 */
export function CompanyPageLayout(props: CompanyPageLayoutProps) {
  const { enableNewNavigation } = featureFlagService()

  if (enableNewNavigation) {
    return <CompanyPageLayoutNew {...props} />
  }

  return <CompanyPageLayoutOld {...props} />
}
